export const XerjoffENPrivacyPolicy = () => (
  <div className="privacy-policy">
    <h2>PRIVACY NOTICE -- IN-STORE DATA COLLECTION</h2>
    <p>
      <strong>Version:</strong> 1.0 | <strong>Date:</strong> 05 March 2026
    </p>

    <section>
      <p>
        This privacy policy concerns the collection of data within
        Xerjoff-branded boutiques via digital devices (tablets) and related CRM
        systems.
      </p>
      <h2>1. Data Controller</h2>
      <p>
        The Data Controller for the personal data collected in the boutique is
        XERJOFF GROUP S.p.A., with registered office at Via Tenivelli 29, 10024
        Moncalieri (TO), Italy, Economic and Administrative Index (REA) 106649,
        Tax Code/VAT No. 09547650011. Its operational headquarters are at Via
        Torino 15, 10044 Pianezza (TO), Italy. The Data Controller can be
        contacted by mail at <a href="mailto:gdpr@xerjoff.com">gdpr@xerjoff.com</a>{' '}
        or by certified email (PEC){' '}
        <a href="mailto:pec@pec.xerjoff.com">pec@pec.xerjoff.com</a>.
      </p>
      <p>
        Xerjoff Group S.p.A. has appointed a Data Protection Officer (DPO), who
        can be contacted at <a href="mailto:dpo@xerjoff.com">dpo@xerjoff.com</a>.
      </p>
    </section>

    <section>
      <h2>2. Categories of personal data</h2>
      <p>
        We may process: first and last name, email address, telephone number,
        date of birth, product preferences and interests, purchase history, data
        relating to interactions with sales staff, and any additional
        information voluntarily provided by the interested party. Data from
        minors is not collected. Furthermore, the provision of special
        categories of data (art. 9 GDPR) is not required. Neither special
        categories of personal data (Article 9 GDPR) nor personal data relating
        to criminal convictions and offences (Article 10 GDPR) are required or
        should be provided.
      </p>
    </section>

    <section>
      <h2>3. How we collect data</h2>
      <p>
        Data is collected: (i) directly from you via in-store tablets; (ii)
        entered by boutique staff at your request; (iii) through integration
        with official brand systems used to manage your customer profile.
      </p>
      <p>
        Before registration, you can review this notice and provide separate
        consents for marketing and profiling.
      </p>
    </section>

    <section>
      <h2>4. Purposes and legal bases</h2>
      <p>
        <strong>a) Registration and relationship management:</strong> to
        register you in our systems and handle your information requests. Legal
        basis: Art. 6(1)(b) GDPR.
      </p>
      <p>
        <strong>b) Direct marketing:</strong> to send marketing communications,
        event invitations, news and offers via email, SMS or other digital
        channels. Legal basis: consent (Art. 6(1)(a) GDPR).
      </p>
      <p>
        <strong>c) Profiling:</strong> to analyze preferences and purchase/contact
        behaviour in order to tailor communications and offers. Legal basis:
        consent (Art. 6(1)(a) GDPR).
      </p>
      <p>
        Marketing and profiling consents are optional, specific and separate
        and can be withdrawn at any time by data subject.
      </p>
    </section>

    <section>
      <h2>5. Whether providing data is mandatory</h2>
      <p>
        Providing registration data may be necessary to take advantage of
        specific initiatives (e.g., receiving requested information).
      </p>
      <p>
        Providing consent for marketing and profiling is optional. Not providing
        consent does not affect your ability to purchase products in-store.
      </p>
    </section>

    <section>
      <h2>6. Processing methods and security measures</h2>
      <p>
        Processing is carried out using electronic and IT tools (tablets, CRM
        systems and management platforms) in accordance with the principles of
        lawfulness, fairness, transparency and data minimization.
      </p>
      <p>
        We implement appropriate technical and organizational measures to
        protect personal data.
      </p>
    </section>

    <section>
      <h2>7. Recipients of personal data</h2>
      <p>
        Personal data may be accessed by the Controller's authorized staff.
      </p>
      <p>
        Data may be disclosed to entities processing data on behalf of the
        Controller as Data Processors (Art. 28 GDPR), such as: IT providers,
        hosting/cloud providers, CRM and marketing automation platforms,
        email/SMS delivery services, and system maintenance/support providers.
      </p>
      <p>
        These recipients include Dylog Italia S.p.A., as provider of the in-store
        data capture/management software used in boutiques.
      </p>
      <p>
        Where required by law or by order of the Authority, the data may be
        communicated to competent public bodies.
      </p>
    </section>

    <section>
      <h2>8. Transfers outside the EEA</h2>
      <p>
        If certain vendors are located outside the European Economic Area,
        transfers will take place in accordance with the GDPR, based on adequacy
        decisions or appropriate safeguards (e.g., Standard Contractual Clauses).
      </p>
    </section>

    <section>
      <h2>9. Data Retention period</h2>
      <p>
        Data processed for marketing and/or profiling purposes is retained for
        up to 7 years from the last meaningful interaction with the brand or
        until you withdraw consent, without prejudice to longer retention
        required by law or for the protection of the Controller's rights.
      </p>
      <p>
        Data needed for administrative/accounting obligations (where applicable)
        will be retained for the periods required by law.
      </p>
    </section>

    <section>
      <h2>10. Your rights</h2>
      <p>
        You may exercise the rights under Articles 15-22 GDPR (access,
        rectification, erasure, restriction, portability, objection) and
        withdraw consent at any time.
      </p>
      <p>
        To exercise your rights:{' '}
        <a href="mailto:gdpr@xerjoff.com">gdpr@xerjoff.com</a> or{' '}
        <a href="mailto:dpo@xerjoff.com">dpo@xerjoff.com</a>.
      </p>
    </section>

    <section>
      <h2>11. Complaints</h2>
      <p>
        If you believe your data has been processed in breach of the GDPR, you
        have the right to lodge a complaint with the Italian Data Protection
        Authority or with the competent supervisory authority in your Member
        State.
      </p>
    </section>

    <section>
      <h2>12. Policy updates</h2>
      <p>
        This notice may be updated from time to time. The most recent version
        will be made available in boutiques and/or through the brand's official
        channels.
      </p>
    </section>
  </div>
);